"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LOGGED_MEETING = exports.LOGGED_EMAIL = exports.LOGGED_CALL = exports.LEGACY_ACTIVITY = exports.SCHEDULE = exports.TASK = exports.CALL_IFRAME = exports.CALL = exports.EMAIL_REPLY = exports.EMAIL = exports.NOTE = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _I18n = _interopRequireDefault(require("I18n"));

var _immutable = require("immutable");

var _EngagementTypes = _interopRequireDefault(require("customer-data-objects/engagement/EngagementTypes"));

var _InteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/communicator/interaction/config/InteractionDescriptorRecord"));

var LocalInteractionTransform = _interopRequireWildcard(require("customer-data-communicator/schema/communicator/interaction/local/LocalInteractionTransform"));

var InteractionTypes = _interopRequireWildcard(require("customer-data-communicator/schema/interactions/InteractionTypes"));

var _PassthruRtePlugins = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/config/PassthruRtePlugins"));

var _EmailInteractionDescriptorRecord = _interopRequireDefault(require("customer-data-communicator/schema/interactions/email/EmailInteractionDescriptorRecord"));

var _EmailAsync = _interopRequireDefault(require("customer-data-communicator/components/interactions/email/EmailAsync"));

var _InteractionWithAutoSave = _interopRequireDefault(require("customer-data-communicator/components/wrappers/InteractionWithAutoSave"));

var _InteractionWithEmailNavigationConfirmation = _interopRequireDefault(require("customer-data-communicator/components/interactions/email/wrappers/InteractionWithEmailNavigationConfirmation"));

var _InteractionWithNavigationConfirmation = _interopRequireDefault(require("customer-data-communicator/components/wrappers/InteractionWithNavigationConfirmation"));

var _InteractionWithValidatedAttachments = _interopRequireDefault(require("customer-data-communicator/components/wrappers/InteractionWithValidatedAttachments"));

var _InteractionWithValidatedEmailAttachments = _interopRequireDefault(require("customer-data-communicator/components/interactions/email/wrappers/InteractionWithValidatedEmailAttachments"));

var _Note = _interopRequireDefault(require("customer-data-communicator/components/interactions/note/Note"));

var _MeetingsAutoDetection = _interopRequireDefault(require("crm_ui/draftjs/plugins/meetings/MeetingsAutoDetection"));

var _MeetingsProTipPlugin = _interopRequireDefault(require("crm_ui/draftjs/plugins/meetings/MeetingsProTipPlugin"));

var _VideoConferencePlugin = _interopRequireDefault(require("customer-data-communicator/lib/draftjs/plugins/videoConference/VideoConferencePlugin"));

var _InteractionValidators = require("crm_ui/components/profile/interactions/common/InteractionValidators");

var _InteractionWithFollowUpTask = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/followUpTask/InteractionWithFollowUpTask"));

var _InteractionWithQueueTask = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/InteractionWithQueueTask"));

var _InteractionWithQueues = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/InteractionWithQueues"));

var _InteractionWithAssociations = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/InteractionWithAssociations"));

var _InteractionWithDefaultContent = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/InteractionWithDefaultContent"));

var _InteractionWithBETAssociations = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/InteractionWithBETAssociations"));

var _InteractionWithBETActivityTypes = _interopRequireDefault(require("crm_ui/BET/activityTypes/components/InteractionWithBETActivityTypes"));

var _InteractionWithTimelineEngagement = _interopRequireDefault(require("crm_ui/components/profile/interactions/wrappers/InteractionWithTimelineEngagement"));

var _SmartTask = _interopRequireDefault(require("crm_ui/components/tasks/SmartTask"));

var LocalCallTransform = _interopRequireWildcard(require("crm_ui/components/profile/interactions/types/call/LocalCallTransform"));

var LocalTaskTransform = _interopRequireWildcard(require("crm_ui/components/profile/interactions/types/task/LocalTaskTransform"));

var _ScheduleAsync = _interopRequireDefault(require("crm_ui/components/profile/interactions/types/schedule/ScheduleAsync"));

var _CallAsync = _interopRequireDefault(require("crm_ui/components/profile/interactions/types/call/CallAsync"));

var _TaskAsync = _interopRequireDefault(require("crm_ui/components/profile/interactions/types/task/TaskAsync"));

var _ActivityAsync = _interopRequireDefault(require("crm_ui/components/profile/interactions/types/activity/ActivityAsync"));

var _InteractionWithInitialEmailContent = _interopRequireDefault(require("crm_ui/components/profile/interactions/types/email/InteractionWithInitialEmailContent"));

var LocalActivityTransform = _interopRequireWildcard(require("crm_ui/components/profile/interactions/types/activity/LocalActivityTransform"));

var _InteractionWithInitialNoteContent = _interopRequireDefault(require("crm_ui/components/profile/interactions/types/note/InteractionWithInitialNoteContent"));

var LocalScheduleTransform = _interopRequireWildcard(require("crm_ui/components/profile/interactions/types/schedule/LocalScheduleTransform"));

var _IsUngatedStore = _interopRequireDefault(require("crm_data/gates/IsUngatedStore"));

var _InteractionWithValidatedAttachmentsComponentConfig = _interopRequireDefault(require("customer-data-communicator/components/wrappers/config/InteractionWithValidatedAttachmentsComponentConfig"));

var _loggers = require("customer-data-tracking/loggers");

var _AsyncComponentErrorHandler = _interopRequireDefault(require("crm_ui/utils/AsyncComponentErrorHandler"));

var _BETAssociationsWrapper = _interopRequireDefault(require("crm_ui/BET/engagementAssociations/components/BETAssociationsWrapper"));

var InteractionWithNavigationConfirmation = (0, _InteractionWithNavigationConfirmation.default)();
var InteractionWithPrivateAttachments = (0, _InteractionWithValidatedAttachments.default)(_InteractionWithValidatedAttachmentsComponentConfig.default.merge({
  onOpenPopover: function onOpenPopover() {
    _loggers.CrmLogger.log('record-interaction', {
      action: 'communicator interaction',
      subAction: 'attach file'
    });
  }
}));
var InteractionWithPrivateCallAttachments = (0, _InteractionWithValidatedAttachments.default)(_InteractionWithValidatedAttachmentsComponentConfig.default.merge({
  onOpenPopover: function onOpenPopover() {
    _loggers.CommunicatorLogger.log('communicatorInteraction', {
      action: 'click to attach file',
      activity: 'call',
      channel: 'outbound call',
      source: 'communicator'
    });
  }
}));

var videoConferenceOnOpenPopover = function videoConferenceOnOpenPopover() {
  _loggers.CrmLogger.log('record-interaction', {
    action: 'communicator interaction',
    subAction: 'crm video link'
  });
};

var getEmailConfig = function getEmailConfig() {
  return import(
  /* webpackChunkName: "communicator-email" */
  '../types/email/EmailInteractionComponentConfig').then(function (mod) {
    return mod.default;
  }).catch((0, _AsyncComponentErrorHandler.default)('email-interaction-config'));
};

var NOTE = (0, _InteractionDescriptorRecord.default)({
  type: InteractionTypes.NOTE,
  icon: 'description',
  label: _I18n.default.text('contactInteraction.createNewNote'),
  onboardingAware: true,
  engagementType: _EngagementTypes.default.NOTE,
  Component: _Note.default,
  wrappers: (0, _immutable.Seq)([_InteractionWithAutoSave.default, InteractionWithPrivateAttachments, _InteractionWithAssociations.default, _InteractionWithInitialNoteContent.default, InteractionWithNavigationConfirmation, _InteractionWithFollowUpTask.default, _InteractionWithQueueTask.default, _InteractionWithQueues.default, _InteractionWithDefaultContent.default, _InteractionWithTimelineEngagement.default, _InteractionWithBETAssociations.default]),
  localTransforms: (0, _immutable.Seq)([LocalInteractionTransform])
});
exports.NOTE = NOTE;

var emailPassThruPlugins = _immutable.Seq.of(_MeetingsProTipPlugin.default, _MeetingsAutoDetection.default);

var EMAIL = _EmailInteractionDescriptorRecord.default.merge({
  label: _I18n.default.text('contactInteraction.createNewEmail'),
  Component: (0, _EmailAsync.default)(getEmailConfig),
  wrappers: (0, _immutable.Seq)([_InteractionWithAutoSave.default, _InteractionWithValidatedEmailAttachments.default, _InteractionWithAssociations.default, _InteractionWithInitialEmailContent.default, _InteractionWithEmailNavigationConfirmation.default, _InteractionWithFollowUpTask.default, _InteractionWithQueueTask.default, _InteractionWithQueues.default, _InteractionWithDefaultContent.default, _InteractionWithTimelineEngagement.default, _InteractionWithBETAssociations.default]),
  passthruRtePlugins: new _PassthruRtePlugins.default({
    plugins: emailPassThruPlugins
  }),
  applicable: (0, _immutable.Seq)([_InteractionValidators.userCanCommunicate, _InteractionValidators.isSalesUser])
});

exports.EMAIL = EMAIL;

var EMAIL_REPLY = _EmailInteractionDescriptorRecord.default.merge({
  label: _I18n.default.text('contactInteraction.createNewEmail'),
  Component: (0, _EmailAsync.default)(getEmailConfig),
  wrappers: (0, _immutable.Seq)([_BETAssociationsWrapper.default, _InteractionWithValidatedEmailAttachments.default, _InteractionWithAssociations.default, _InteractionWithFollowUpTask.default, _InteractionWithBETAssociations.default, _InteractionWithDefaultContent.default]),
  passthruRtePlugins: new _PassthruRtePlugins.default({
    plugins: emailPassThruPlugins
  }),
  applicable: (0, _immutable.Seq)([_InteractionValidators.userCanCommunicate, _InteractionValidators.isSalesUser])
});

exports.EMAIL_REPLY = EMAIL_REPLY;
var CALL = (0, _InteractionDescriptorRecord.default)({
  type: InteractionTypes.CALL,
  icon: 'calling',
  label: _I18n.default.text('contactInteraction.placeCall'),
  engagementType: _EngagementTypes.default.CALL,
  Component: _CallAsync.default,
  wrappers: (0, _immutable.Seq)([_InteractionWithAutoSave.default, InteractionWithPrivateCallAttachments, _InteractionWithAssociations.default, InteractionWithNavigationConfirmation, _InteractionWithFollowUpTask.default, _InteractionWithBETActivityTypes.default, _InteractionWithQueueTask.default, _InteractionWithQueues.default, _InteractionWithDefaultContent.default, _InteractionWithTimelineEngagement.default, _InteractionWithBETAssociations.default]),
  localTransforms: (0, _immutable.Seq)([LocalInteractionTransform, LocalCallTransform]),
  applicable: (0, _immutable.Seq)([_InteractionValidators.userCanCommunicate, _InteractionValidators.isSalesUser])
});
exports.CALL = CALL;
var CALL_IFRAME = (0, _InteractionDescriptorRecord.default)({
  type: InteractionTypes.CALL,
  icon: 'calling',
  label: _I18n.default.text('contactInteraction.placeCall'),
  engagementType: _EngagementTypes.default.CALL,
  Component: _CallAsync.default,
  wrappers: (0, _immutable.Seq)([_InteractionWithAutoSave.default, InteractionWithPrivateAttachments, _InteractionWithAssociations.default, InteractionWithNavigationConfirmation, _InteractionWithFollowUpTask.default, _InteractionWithBETActivityTypes.default, _InteractionWithDefaultContent.default, _InteractionWithTimelineEngagement.default, _InteractionWithBETAssociations.default]),
  localTransforms: (0, _immutable.Seq)([LocalInteractionTransform, LocalCallTransform]),
  applicable: (0, _immutable.Seq)([_InteractionValidators.userCanCommunicate, _InteractionValidators.isSalesUser])
});
exports.CALL_IFRAME = CALL_IFRAME;
var TASK = (0, _InteractionDescriptorRecord.default)({
  type: InteractionTypes.TASK,
  icon: 'tasks',
  label: _I18n.default.text('contactInteraction.createNewTask'),
  engagementType: _EngagementTypes.default.TASK,
  Component: _TaskAsync.default,
  wrappers: (0, _immutable.Seq)([_InteractionWithAutoSave.default, _InteractionWithAssociations.default, InteractionWithNavigationConfirmation, _SmartTask.default, _InteractionWithQueues.default, _InteractionWithDefaultContent.default, _InteractionWithTimelineEngagement.default, _InteractionWithBETAssociations.default]),
  localTransforms: (0, _immutable.Seq)([LocalInteractionTransform, LocalTaskTransform]),
  applicable: (0, _immutable.Seq)([_InteractionValidators.isSalesUser])
});
exports.TASK = TASK;
var SCHEDULE = (0, _InteractionDescriptorRecord.default)({
  type: InteractionTypes.SCHEDULE,
  icon: 'meetings',
  label: _I18n.default.text('contactInteraction.scheduleEvent'),
  engagementType: _EngagementTypes.default.MEETING,
  Component: _ScheduleAsync.default,
  wrappers: (0, _immutable.Seq)([_InteractionWithAutoSave.default, InteractionWithPrivateAttachments, _InteractionWithAssociations.default, InteractionWithNavigationConfirmation, _InteractionWithQueueTask.default, _InteractionWithQueues.default, _InteractionWithDefaultContent.default, _InteractionWithTimelineEngagement.default, _InteractionWithBETAssociations.default]),
  passthruRtePlugins: new _PassthruRtePlugins.default({
    plugins: _IsUngatedStore.default.get('CRM:VideoConferencePlugin') ? _immutable.Seq.of((0, _VideoConferencePlugin.default)({
      onOpenPopover: videoConferenceOnOpenPopover
    })) : (0, _immutable.Seq)()
  }),
  localTransforms: (0, _immutable.Seq)([LocalInteractionTransform, LocalScheduleTransform]),
  applicable: (0, _immutable.Seq)([_InteractionValidators.userCanCommunicate, _InteractionValidators.isSalesUser])
});
exports.SCHEDULE = SCHEDULE;
var LOGGED_ACTIVITY_RECORD_PROPERTIES = {
  icon: 'add',
  engagementType: null,
  Component: _ActivityAsync.default,
  wrappers: (0, _immutable.Seq)([_InteractionWithAutoSave.default, InteractionWithPrivateAttachments, _InteractionWithAssociations.default, InteractionWithNavigationConfirmation, _InteractionWithFollowUpTask.default, _InteractionWithBETActivityTypes.default, _InteractionWithQueueTask.default, _InteractionWithQueues.default, _InteractionWithDefaultContent.default, _InteractionWithTimelineEngagement.default, _InteractionWithBETAssociations.default]),
  localTransforms: (0, _immutable.Seq)([LocalActivityTransform]),
  applicable: (0, _immutable.Seq)([_InteractionValidators.userCanCommunicate, _InteractionValidators.isSalesUser])
};
var LEGACY_ACTIVITY = (0, _InteractionDescriptorRecord.default)((0, _extends2.default)({
  type: InteractionTypes.LEGACY_ACTIVITY,
  label: _I18n.default.text('contactInteraction.logActivity')
}, LOGGED_ACTIVITY_RECORD_PROPERTIES));
exports.LEGACY_ACTIVITY = LEGACY_ACTIVITY;
var LOGGED_CALL = (0, _InteractionDescriptorRecord.default)((0, _extends2.default)({
  type: InteractionTypes.LOGGED_CALL,
  label: _I18n.default.text('contactInteraction.logCall')
}, LOGGED_ACTIVITY_RECORD_PROPERTIES, {
  engagementType: _EngagementTypes.default.CALL
}));
exports.LOGGED_CALL = LOGGED_CALL;
var LOGGED_EMAIL = (0, _InteractionDescriptorRecord.default)((0, _extends2.default)({
  type: InteractionTypes.LOGGED_EMAIL,
  label: _I18n.default.text('contactInteraction.logEmail')
}, LOGGED_ACTIVITY_RECORD_PROPERTIES, {
  engagementType: _EngagementTypes.default.EMAIL
}));
exports.LOGGED_EMAIL = LOGGED_EMAIL;
var LOGGED_MEETING = (0, _InteractionDescriptorRecord.default)((0, _extends2.default)({
  type: InteractionTypes.LOGGED_MEETING,
  label: _I18n.default.text('contactInteraction.logMeeting')
}, LOGGED_ACTIVITY_RECORD_PROPERTIES, {
  engagementType: _EngagementTypes.default.MEETING
}));
exports.LOGGED_MEETING = LOGGED_MEETING;